import Header from '../components/Header';
import GrafanaDashboard from '../components/GrafanaDashboard';
import AlertOverlay from '../components/AlertOverlay';
import useAlertPolling from '../hooks/useAlertPolling';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    height: '100%',
    width: '100%',
  },
});

export default function LiveDashboard() {
  const styles = useStyles();
  const { activeAlerts, isConnected, acknowledge, isAcknowledging, ackError, confirmedId } = useAlertPolling();

  const currentAlert = activeAlerts.length > 0 ? activeAlerts[0] : null;

  return (
    <>
      <Header alertConnected={isConnected} />
      <div className={styles.root}>
        <GrafanaDashboard />
      </div>
      {isConnected && currentAlert && (
        <AlertOverlay
          alert={currentAlert}
          onAcknowledge={acknowledge}
          isAcknowledging={isAcknowledging}
          ackError={ackError}
          isConfirmed={confirmedId === currentAlert.id}
        />
      )}
    </>
  );
}
